const API_BASE_URL =
  process.env.REACT_APP_BASE_API_URL ||
  process.env.REACT_APP_BASE_API ||
  "http://localhost:8000/api/";

const customFetch = async (url, options = {}) => {
  const token = localStorage.getItem("token");

  const defaultHeaders = {
    "Content-Type": "application/json",
    "ngrok-skip-browser-warning": "true",
  };

  if (token) {
    defaultHeaders["Authorization"] = `Bearer ${token}`;
  }

  const fullUrl = `${API_BASE_URL}${url}`;

  return fetch(fullUrl, {
    ...options,
    headers: {
      ...defaultHeaders,
      ...options.headers,
    },
  }).then(async (response) => {

    console.log("🚀 ~ customFetch ~ response:", response);
    const contentType = response.headers.get("content-type");
    let data;
    if (contentType && contentType.indexOf("application/json") !== -1) {
      data = await response.json();
    } else {
      data = await response.text();
    }

    if (!response.ok) {
      const error = new Error(data.message || "Network response was not ok");
      error.response = data;
      throw error;
    }

    return data;
  });
};

export default customFetch;
